var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scroll",staticClass:"scroll-wrap"},[_c('div',{ref:"scroll_el",staticClass:"scroll-content"},[_vm._t("default",null,{"list":_vm.filterList})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }